import { CompareTableColumn } from "in_queue/components/compare/comparisons";
import { ScenarioProject } from "in_queue/types/scenarioResultType";
import {
    currencyFormatter,
    roundingFormatter
} from "../tables/agGrid/agGridHelpers";
import { FuelTypeCellRenderer } from "../tables/agGrid/cellRenderers";

export const makeProjectsCompareColumns = (
    fuelTypeByProjectId: Readonly<Record<string, string>>
): ReadonlyArray<CompareTableColumn<ScenarioProject>> => [
    {
        kind: "join",
        colId: "projectId",
        headerName: "Project",
        getValue: (r) => r.projectId,
        flex: 2
    },
    {
        kind: "display",
        colId: "fuelType",
        headerName: "Fuel type",
        getValue: (rep) => fuelTypeByProjectId[rep.projectId] ?? "",
        cellRenderer: FuelTypeCellRenderer,
        flex: 2
    },
    {
        kind: "compare",
        colId: "costPerMw",
        headerName: "$ / MW",
        getValue: (r) => r.costPerMw ?? null,
        valueFormatter: currencyFormatter,
        sort: "desc",
        flex: 1
    },
    {
        kind: "compare",
        colId: "sumAllocatedCost",
        headerName: "Allocated cost",
        getValue: (r) => r.sumAllocatedCost,
        valueFormatter: currencyFormatter,
        flex: 1
    },
    {
        kind: "compare",
        colId: "numSharedUpgrades",
        headerName: "# Shared upgrades",
        getValue: (r) => r.numSharedUpgrades,
        valueFormatter: roundingFormatter,
        hideDelta: true,
        filterable: false,
        flex: 1
    }
];
